
import { Component, Vue, Prop } from "vue-property-decorator";
import WorkingHours from "../../../domain/restaurant/WorkingHours";
import { VuetifyForm } from "@/plugins/vuetify";
import RemoteServices from "@/services/RemoteServices";
import ConfirmationDialog from "@/components/alert/ConfirmationDialog.vue";
import DialogBanner from "@/components/app/DialogBanner.vue";
@Component({
  components: { ConfirmationDialog, DialogBanner }
})
export default class WorkingHoursDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({
    default: () => {
      return new WorkingHours();
    }
  })
  workingHours!: WorkingHours;

  workingHoursCopy = WorkingHours.copy(this.workingHours);
  startTimePicker = false;
  endTimePicker = false;
  formValid = false;

  titleMenu = false;
  required = [(v: string) => !!v || "Required"];
  showTitleMenu() {
    this.titleMenu = true;
  }

  getBannerTitle() {
    if (this.newWorkingHours) {
      return this.$t("workingHours.create.message");
    }
    return this.$t("workingHours.edit.message");
  }

  toggleStartTimePicker() {
    this.startTimePicker = !this.startTimePicker;
  }

  toggleEndTimePicker() {
    this.endTimePicker = !this.endTimePicker;
  }

  get confirmationDialog() {
    return this.$refs.confirmationDialog as ConfirmationDialog;
  }

  get dialog() {
    return this.value;
  }

  set dialog(newValue) {
    this.$emit("input", newValue);
  }

  get newWorkingHours() {
    return this.workingHours.workingHoursId == null;
  }

  get form() {
    return this.$refs.workingHoursForm as VuetifyForm;
  }

  get hasChanged() {
    return WorkingHours.haveDifferences(
      this.workingHours,
      this.workingHoursCopy
    );
  }

  get startTime() {
    if (this.workingHoursCopy.startTime == null) return "00:00";
    return this.workingHoursCopy.startTime;
  }

  get endTime() {
    if (this.workingHoursCopy.endTime == null) return "23:59";
    return this.workingHoursCopy.endTime;
  }

  allowedMinutes(m: number) {
    return m % 5 === 0;
  }

  async createWorkingHours() {
    await this.form.validate();
    if (this.formValid) {
      this.$store.dispatch("loading");
      try {
        this.workingHoursCopy.restaurantId = await this.getSelectedRestaurantId();
        this.workingHoursCopy = await RemoteServices.createWorkingHours(
          this.workingHoursCopy,
          this.workingHoursCopy.restaurantId
        );
        this.$store.dispatch("success", this.$t("workingHours.create.success"));
        this.addNewWorkingHours();
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  async submitChanges() {
    await this.form.validate();
    if (this.formValid) {
      this.$store.dispatch("loading");
      try {
        this.workingHoursCopy.restaurantId = await this.getSelectedRestaurantId();
        this.workingHoursCopy = await RemoteServices.updateWorkingHours(
          this.workingHoursCopy,
          this.workingHoursCopy.restaurantId
        );
        this.updateWorkingHours();
        this.dialog = false;
        this.$store.dispatch("success", this.$t("workingHours.edit.success"));
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  async deleteWorkingHours() {
    if (
      await this.confirmationDialog.open(
        this.$tc("workingHours.delete.message"),
        this.$t("delete.confirmation") +
          "\n" +
          this.workingHours.workingHoursName +
          "\n" +
          this.$t("delete.warning")
      )
    ) {
      try {
        this.$store.dispatch("loading");
        await RemoteServices.deleteWorkingHours(
          this.workingHours.workingHoursId,
          this.workingHours.restaurantId,
          ""
        );
        this.$store.dispatch("success", this.$t("workingHours.delete.success"));
        this.removeWorkingHours();
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.$store.dispatch("clearLoading");
    }
  }

  updateWorkingHours() {
    WorkingHours.update(this.workingHours, this.workingHoursCopy);
  }

  addNewWorkingHours() {
    this.$emit("new-working-hours", this.workingHoursCopy);
  }

  removeWorkingHours() {
    this.$emit("delete-working-hours", this.workingHours);
  }

  async getSelectedRestaurantId(): Promise<number> {
    return await this.$store.getters.getSelectedRestaurant.restaurantId;
  }
}
